import { render, staticRenderFns } from "./deletePendientes.vue?vue&type=template&id=6e08e682&"
import script from "./deletePendientes.vue?vue&type=script&lang=js&"
export * from "./deletePendientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports